<template>
  <md-toolbar
    md-elevation="0"
    class="md-transparent"
    id="topNavToolbar"
    :class="{
      'md-toolbar-absolute md-white md-fixed-top': $route.meta.navbarAbsolute
    }"
  >
    <div class="md-toolbar-row">
      <div class="md-toolbar-section-start">
        <h3 class="md-title">{{ $route.name }}</h3>
      </div>
      <div class="md-toolbar-section-end">
        <md-button
          class="md-just-icon md-round md-simple md-toolbar-toggle"
          :class="{ toggled: $sidebar.showSidebar }"
          @click="toggleSidebar"
        >
          <span class="icon-bar"></span>
          <span class="icon-bar"></span>
          <span class="icon-bar"></span>
        </md-button>

        <div class="md-collapse">
          <md-list>
            <md-list-item :to="{ name: 'Dashboard' }">
              <i class="material-icons">dashboard</i>
              <p class="hidden-lg hidden-md">Dashboard</p>
            </md-list-item>

            <li class="md-list-item" id="topBarNotices">
              <div class="md-list-item-content">
                <drop-down direction="down">
                  <md-button
                    slot="title"
                    class="md-button md-just-icon md-simple"
                    data-toggle="dropdown"
                  >
                    <md-icon>notifications</md-icon>
                    <span v-if="notificationCount > 0" class="notification">{{
                      notificationCount
                    }}</span>
                    <p class="hidden-lg hidden-md">Notifications</p>
                  </md-button>
                  <div
                    class="dropdown-menu dropdown-menu-right"
                    id="userNotifications"
                    @click.stop
                  >
                    <div
                      class="notification-actions"
                      v-if="notificationCount > 0"
                    >
                      <a href="#" @click.prevent="clearAll">Clear All</a>
                    </div>
                    <ul>
                      <template v-if="notificationCount > 0">
                        <li
                          class="md-layout"
                          v-for="notification in unreadNotifications"
                          v-bind:key="notification.id"
                        >
                          <a
                            class="md-layout-item md-size-90 userNotification"
                            href="#"
                            @click.prevent="actionNotice(notification)"
                            >{{ notification.data.message }}</a
                          >
                          <div class="md-layout-item md-size-10 text-right">
                            <md-button
                              class="md-just-icon md-simple md-danger"
                              @click.prevent="markAsRead(notification)"
                            >
                              <md-icon>delete</md-icon>
                              <md-tooltip md-direction="top"
                                >Mark As Read</md-tooltip
                              >
                            </md-button>
                          </div>
                        </li>
                      </template>
                      <template v-else>
                        <li>
                          <a href="#"
                            >Nothing of interest has happened for a while!</a
                          >
                        </li>
                      </template>
                    </ul>
                  </div>
                </drop-down>
              </div>
            </li>
          </md-list>
        </div>
      </div>
    </div>
  </md-toolbar>
</template>

<script>
import notificationApi from "@/services/api/notification";
import echo from "@/services/broadcasting/echo";
import moment from "moment";

export default {
  data() {
    return {
      notifications: []
    };
  },

  computed: {
    notificationCount: function() {
      return this.unreadNotifications.length;
    },
    unreadNotifications: function() {
      return this.notifications.filter(notification => {
        return notification.read_at === null;
      });
    }
  },

  created() {
    const user = this.$store.state.auth.user;

    echo.private(`managers.${user.id}`).notification(notification => {
      this.notifications.unshift(notification);
    });

    this.getNotifications();
  },

  mounted() {},

  methods: {
    getNotifications() {
      notificationApi.getNotifications().then(response => {
        this.notifications = response.data;
      });
    },

    markAsRead(notification) {
      notificationApi.markAsRead(notification.id).then(response => {
        notification.read_at = moment().format();
      });
    },

    actionNotice(notification) {
      this.$router.push(notification.data.link).catch(err => {
        if (err.name != "NavigationDuplicated") {
          throw error;
        }
      });
    },

    toggleSidebar() {
      this.$sidebar.displaySidebar(!this.$sidebar.showSidebar);
    },

    clearAll() {
      notificationApi.clearAll().then(response => {
        this.getNotifications();
      });
    },

    minimizeSidebar() {
      if (this.$sidebar) {
        this.$sidebar.toggleMinimize();
      }
    }
  }
};
</script>
<style lang="scss" scoped>
#topNavToolbar {
  z-index: 3;
}

#topBarNotices {
  ul {
    list-style-type: none;
    padding: 0;
  }

  .notification-actions {
    background-color: #e8f8fa;
    padding: 5px 10px;
    display: flex;
    justify-content: flex-end;

    a:hover {
      text-decoration: underline !important;
    }
  }

  .md-list-item-content {
    padding: 0 7px;
  }

  #userNotifications {
    .md-layout-item {
      padding-left: 10px;
      padding-right: 10px;
    }
    .md-button.md-just-icon {
      min-height: 35px;
      height: 35px;
      line-height: 35px;
    }
  }

  .dropdown-menu li {
    width: 375px;

    .userNotification {
      white-space: inherit;
      margin: 0;
      padding: 5px 10px;
    }
  }
}
</style>
